/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { call, put, takeLatest } from 'redux-saga/effects';

import { PlanApiService } from '../../services/PlanApiService';
import { ApiClientError } from '../../types/api/ApiClientError';
import { ApiClientResponse } from '../../types/api/ApiClientResponse';
import { ProductPlanTypeResponsePayload } from '../../types/product/ProductPlanTypeResponsePayload';
import { fetchPlanActions } from './actions';
import { GetPlanWatcherAction, PlanActions } from './types';

export function* fetchProductPlansSaga(action: GetPlanWatcherAction): Generator {
  const { serviceType } = action.payload;
  yield put(fetchPlanActions.request());
  try {
    const callResult = yield call(PlanApiService.fetchProductPlans, { serviceType });
    const result = callResult as ApiClientResponse<ProductPlanTypeResponsePayload>;
    yield put(fetchPlanActions.success(result.data.payload));
  } catch (e) {
    yield put(fetchPlanActions.error((e as ApiClientError).response?.data.message));
  }
}

export function* planMainSaga() {
  yield takeLatest(PlanActions.GET_PLAN_WATCHER, fetchProductPlansSaga);
}
